import React from 'react';
import NavbarTop from '../components/NavbarTop';
import NavbarBottom from '../components/NavbarBottom';
import UserDetails from '../components/UserDetails';

const UserProfile = () => {
  return (
    <div>
      <NavbarTop />
      <UserDetails />
      <NavbarBottom />
    </div>
  );
};

export default UserProfile;
